import "./TopContributors.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from "../config";
import { getStorage } from "../utils/wallet";

export default function TopContributors( { preview } ) {

  const [items, setItems] = useState();

  useEffect(() => {

    getStorage((storage) => {
      
      var maxEntries = 100;
      if(preview) maxEntries = 5;

      var _data = [];
      for(var _entry of storage.contributions.entries()){
        _data.push({address: _entry[0], amount: _entry[1].c[0]});
      }

      _data.sort(function(a,b){
        return b.amount - a.amount;
      })

      console.log(_data);

      maxEntries = Math.min(maxEntries, _data.length);

      var _newData = [];
      for(var i=0; i<maxEntries; i++){
        var _nd = _data[i];
        _nd.rank = i+1;
        _newData.push(_nd);
      }

      //console.log(_newData);

      setItems(_newData);

    })

  }, []);

  return (
    <div className="top-contributors">
 
      <h1>Top Contributors</h1>

      {items && <Panel items={items} />}

      <br />
      {preview && <Link to="/PixelPlace/contributors">View top 100 contributors</Link>}
      <br />
      <br />

    </div>
  );
}

function Panel({ items }){

  return(
    <>
      <table>
        <thead>
          <tr>
            <th>Rank</th>
            <th>User</th>
            <th>Pixels Placed</th>
          </tr>
        </thead>
        <tbody>
          {items.map(item => (
              <Entry entry={item} />
          ))}
        </tbody>
      </table>
    </>
  );
}

function Entry({ entry }){

  //https://api.tzkt.io/v1/accounts/tz1gn4ohZwKWSnJ1HNhC9x3kJ8ntUTNWAh4Y/metadata

  const [items, setItems] = useState();

  useEffect(() => {
    var _str = "https://api.tzkt.io/v1/accounts/"
    var _str2 = "/metadata";
    fetch(_str + entry.address + _str2)
    .then(response => response.json())
    .then((data) => {
      var _newData = entry;
      if(data.alias) _newData.name = data.alias;
      setItems(_newData);
    })
    .catch(() => {
      var _newData = entry;
      _newData.name = _newData.address.substring(0,5) + "..." + _newData.address.slice(-5)
      setItems(_newData);
    })

  }, []);

  return(
    <>
      {items && 
        <tr>
          <th>#{items.rank}</th>
          <th><a href={"https://tzkt.io/" + items.address}>{items.name || items.address}</a></th>
          <th>{items.amount}</th>
        </tr>
      }
    </>
  )

}